import { Modal } from '../../../Modal';
import { Title } from '../../../Typography/components';
import * as React from 'react';
import * as styles from '../../../Combobox/components/SelectModal/styles.css';
import { Button } from '../../../Button';

interface IProps {
  isOpen?: boolean;
  handleClose: () => void;
  handleConfirm: () => void;
}

export const ResetFiltersModal: React.FC<IProps> = ({ isOpen, handleClose, handleConfirm }) => {
  return (
    <Modal
      isOpen={!!isOpen}
      onClose={handleClose}
      header={
        <div className={styles.header}>
          <Title level={6}>Сбросить все фильтры?</Title>
        </div>
      }
    >
      <div className={styles.buttons}>
        <Button fullWidth theme="fill_secondary" onClick={handleClose}>
          Отмена
        </Button>

        <Button fullWidth onClick={handleConfirm}>
          Сбросить
        </Button>
      </div>
    </Modal>
  );
};
